<style lang="scss">
  .pdf-modal {
    .ivu-modal-body {
      height: 60vh;
    }
  }
  .video-loader{
    background: #ffffffad;
    position: absolute;
    top: 48%;
    left: 50%;
    height: 66px;
    width: 66px;
    text-align: center;
    font-size: 46px;
    color: var(--primary-color);
    transform: translate(-50%, -50%);
    border-radius: 7px;
  }

  .p-relative {
    position: relative;
  }

  .compound-text:empty {
    padding: 0px;
  }

  .compound-text {
    all: initial;
    all: unset;
    ol {
      list-style-type: decimal !important;
    }
  }

  .compound-text p img {
    max-width:100%;
    text-indent:-9999999px
  }

  .compound-text ol li {
    list-style-type: number !important;
    font-size: initial;

  }

  .compound-text ol {
    margin: initial !important;
    padding: 0 1.3em !important;
    margin-left:1.3em !important;
  }

  .compound-text ul {
    margin: initial !important;
    margin-left:1.3em !important;
    padding: 0 1.3em !important;
  }

  .compound-text ul li {
    list-style-type: disc !important;
    font-size: initial;
  }

  .compound-text ul,
  .compound-text ol{
    margin-bottom: 15px !important;
  }

  .compound-text {
    p,
    h3,
    h4 {
      margin-bottom: 10px;
      font-size: initial !important;
    }

    h1,
    h2
     {
      margin-bottom: 10px;
    }

    em {
      font-size: inherit;
    }

    audio + p:nth-last-of-type(1) > br{
      display: none  
    }
  }

  .compound-text br {
    // display: none;
  }

  .podcast-component{
    padding: 12px 15px;
  }

  .ql-editor-podcast {    
      height: 32px !important;
  }

  .ql-editor-podcast-full-width {    
    width: 100% !important;
  }
</style>

<style scoped lang="scss">
@keyframes blink {
  from {
    color: #eeee;
  }
  to {
    color: var(--link-color);
  }
}


.pdf-item {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 4px;
  margin: 12px 15px;
  cursor: pointer;
  .pdf-img {    
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 50px;
    height: 50px;
    min-width: 50px;
    max-height: 50px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50px;
    flex: 0 0 50px;
    // background-color: #212529;
    color: gray;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: 10px;
  }
  .pdf-text-info {
    position: relative;
    min-height: 50px;
    display: block;
    font-size: 12px !important;
    font-family: Helvetica !important;
  }
}

.toc-title  {
  /* display: none; */
  /* font-style: bold; */
  font-weight: bold;
  font-size: 80%;
  padding-left: 25px;
  background: white;
  display: flex;
  align-items: center;
  // padding-top: 30px;
  color: var(--link-color);
  .pointer {
    margin-right: 8px;
  }
}
.blink {
  animation-duration: 600ms;
  animation-name: blink;
  animation-iteration-count: 4;
  animation-direction: alternate;
}
.progressive-image {
  max-width: 100% !important;
}

.image-preview-container {
  height: 200px;
  overflow: hidden;
  text-align: center;
  background: #fff;
  width: 100%;
  margin: 0 auto;
}
.image-preview-container > img {
  height: 100%;
  width: auto;
  margin: 0 auto;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  } 50% {
    transform: rotate(180deg);
  } to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

/* .feed-list-page-template .ivu-avatar-large{
  width: 54px;
  height: 54px;
} */

.multiline-ellipsis {
    display: block;
    display: -webkit-box;
    max-width: 400px;
    /* min-height: 25px; */
    line-height: 20px;
    /* margin: 0 auto; */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right:15px !important;
}

.options-menu > * {
  display: block;
  padding: 8px 16px;
  text-decoration: none;
  color: #1c2438;
}

.options-menu > *:active {
  background: #f1f1f1;
}

.options-menu > *:not(:first-child):not(:last-child) {
}

.card-holder {
  width: 100%;
  /* height: 130px; */
  background: #fff;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.card-holder-event {
  height: 90px;
}

.event-desc{
  -webkit-line-clamp: 2!important;
}

.card-holder.reverse{
  flex-direction: row-reverse;
}

.card-holder > .feed-details,.card-holder > .image{
  /* flex-grow: 1;
  flex-basis: 0; */
  height: 100%;
}

.card-holder > .feed-details{
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px;
}

.card-holder > .image{
  background-repeat: no-repeat !important;
  background-position: center !important;
  -webkit-background-size: cover !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
  width:50%;
  padding: 10px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.feed-icon{
  width:35px;
  height:35px;
  border-radius:100%;
  background:rgba(255,255,255,.9);
  color:#333;
  border:1px solid #333;
  font-size:20px
}

.featured-users-holder{
  display: flex;
  flex-direction: column;
  padding: 3px 0 8px;
}

.featured-users-holder > .header {
  margin-bottom: 10px;
}

.featured-users-holder > .users{
  display: flex;
  overflow: auto;
}

.featured-users-holder > .users > .user{
  min-width: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  text-align: center;
}
.artwork-title-padding {
  padding-right: 20px;
}
</style>

<style>
.options-menu .options-menu {
  padding: unset;
}
.play-icon > i.ivu-icon.ivu-icon-play {
  padding-left:5px !important;
}
.test{
  div {
      text-align: justify;
    }

  div:after {
        content: "";
        display: inline-block;
        width: 100%;
  }
}

.feedicon > .ivu-btn > .ivu-icon + span, .ivu-btn > span + .ivu-icon {
    margin-left: 0px;
}

.trash-btn:hover{
  color: #57a3f3;
}
</style>

<template>
    <div class="feed-list-page-template">
      <Modal
        v-model="showSinglePreview"
        @on-cancel="showSinglePreview = false">
        <div slot="header">
          <br>
        </div>
        <div
          style="display:flex; justify-content: center;">
          <Spin
            v-if="isSinglePreviewLoading"/>
          <CourseComponent style="margin: 0px -10px; max-width: -webkit-fill-available; width: 100%;" :section="'group'" v-if="!isSinglePreviewLoading && singleFeedItem && isGuid(singlePreviewItemId)" :pSingleFeedItem="singleFeedItem"/>
          <iframe v-else-if="singlePreviewItemId && !isGuid(singlePreviewItemId)" style="height: 60vh;margin: 0;width: 100%;border: none;" :src="singlePreviewItemId"></iframe>
        </div>
        <div slot="footer">
          <p></p>
        </div>
      </Modal>

        <Row type="flex" justify="center" style="padding-top: 4px; background: white">
            <Col :span="24" v-if="isFeed == 'HomePage' && false">
              <Card shadow :style="{borderRadius: '0', marginBottom: '10px'}" :padding="0">
                <div class="featured-users-holder">
                  <div class="header">
                    <small style="color: rgb(170, 170, 170);padding-left:8px"><b>Featured Members</b></small>
                    <small @click="goToPeople" style="position:absolute; right:10px; line-height: 23px;padding-left:8px"><a>See all</a></small>
                  </div>
                  <VueContentLoading :width="313" :height="81" style="height: 100%" v-if="showFeaturedMembersLoading">
                    <circle cx="33" cy="30" r="26" />
                    <rect x="8" y="62" rx="4" ry="4" width="50" height="10" />
                    <circle cx="91" cy="30" r="26" />
                    <rect x="66" y="62" rx="4" ry="4" width="50" height="10" />
                    <circle cx="149" cy="30" r="26" />
                    <rect x="124" y="62" rx="4" ry="4" width="50" height="10" />
                  </VueContentLoading>
                  <div class="users" v-if="featuredUsers">
                    <div class="user" v-for="(user, indx) in featuredUsers.subscribers" :key="indx" v-on:click="reRouteUser(user.id)" v-if="profileInfo.id != user.id">
                      <Avatar icon="person" :src="userDisplayImage(user)" size="large" style="width:60px;height:60px;border-radius:100%;background:white;border:1px solid rgb(221, 221, 221);" />
                      <p class="truncate" style="padding: 0 10px;margin-top: 5px; display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;">
                        <span>{{user.first_name}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
            <p v-if="isFeed == 'HomePage' && newFeedAvailable" style="margin-bottom:10px;width:100%;padding:0 10px">
              <Affix :offset-top="getOffsetnewFeedAvailable" @on-change="change">
                <i-button v-show="sticky" shape="circle" @click="applyUpcommingToFeed()" long>
                  <a>New Content available</a>
                </i-button>
              </Affix>
              <i-button v-show="!sticky" shape="circle" @click="applyUpcommingToFeed()" long>
                <a>New Content Available</a></i-button>
            </p>
            <Col :span="24" v-for="(item, k) in orderedFeeds" :id="item.id" :key="k" v-show="item.type !== 'apply_volunteer' && !groupFeedLoader">
                  <div @click="scrollToTop" v-if="item.type == 'anchor'" :style="tocTitleStyle(k+1)" class="toc-title">
                    <div class="pointer" style="display: flex;">
                      <Icon size="24" type="arrow-up-b"/>
                    </div>
                    <span class="pointer">
                      {{item.title}}
                    </span>
                  </div>
                  <ActivityDropdownContext v-if="!broadcastOnly" :activity-element="item" /> 
                  <div class="card-holder" 
                    :style="{'background-color': item.data ? item.data.backgroundColor : '', 'background-image': item.data && item.data.backgroundImage ? 'url('+ item.data.backgroundImage +')' : '', marginBottom: isInfo ? '10px':'0'}" 
                    style="flex-direction: column-reverse; z-index:99999" 
                    :class="(item.type=='event_info') ? 'card-holder-event element-id-' + item.id : 'element-id-' + item.id">
                    <p v-if="item.data.citation" style="color:var(--primary-color);font-size:10px;padding: 5px 15px;font-style:italic">{{item.data.citation}}</p>
                    <div class="feed-details">
                      <p v-show="isInfo"><b>{{item.title}}</b></p>
                      <div type="flex">
                        <a  v-if="section != 'journal' && section != 'group' && !item.cover_photo_uri && item.type != 'event_info'">
                          <Avatar shape="square" size="default" :src="posterPreviewImage(item)" :style="{float:'left', marginRight: '10px'}" />
                        </a>
                        <div style="display:-webkit-box;" v-show="false">
                          <small>
                            <b style="padding: 8px 10px; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden; font-size: 14px;line-height:1.2em;"
                              :class="{ 'artwork-title-padding': isFeed === 'ResourceSinglePage' && singleResource.data.type === 'artwork' }">{{titlePreview(item)}}</b>
                            <small @click="viewActivity(item)" v-if=" item.careplan && titlePreview(item) != item.careplan.title"/>
                            <span @click="copyToClipboard(item)" v-if="isFeed === 'ResourceSinglePage' && singleResource.data.type === 'artwork'">
                              <span style="position:absolute;top:0;right:0;float:right;padding:10px"><i style="font-size:20px" class="far fa-copy"></i></span>
                            </span>
                            <!-- <p v-if="section != 'journal' && section != 'group'" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden; font-size: 0.9em">{{item.careplan.title}}</p> -->
                          </small>
                        </div>
                      </div>
                      <div v-if="(item.data && isPodcastFile(item))" class="podcast-component">
                        <b>{{item.title}}</b>
                        <audio-player 
                          style="margin: 8px 0px"
                          v-if="(item.type == 'podcast' || item.type == 'podcast_object') && (item.data && item.data.podcast)"
                          :src="item.data.podcast"/>
                      </div>
                      <p v-if="!isPdfFile(item) && (!item.cover_photo_uri || item.type == 'event_info')" 
                        :class="item.type == 'event_info' ? 'event-desc':''" 
                        class="compound-text" style="overflow: hidden;" 
                        v-html="contentDisplay(item)"></p>
                      <!-- <Avatar style="position: absolute;bottom: 10px; right:10px" :src="item.careplan.thumbnail_photo[0].medium" size="small" v-if="item.careplan && isFeed == 'HomePage' && item.day != -1 && item.careplan.id != groupID.donate && item.cover_photo_uri && item.type != 'event_info'"/> -->
                      <div v-if="isModeration" class="feedicon" style="position: absolute;bottom: 5px;right: 10px;">
                          <Button @click="approveItem($event,item)" icon="checkmark" style="padding: 2px;" type='text'>Approve</Button>
                          <Icon v-if="item" @click="deleteItem(item.id, item)" class="trash-btn" type="ios-trash-outline" style="cursor:pointer;font-size:20px;padding:2px 10px;float:right"></Icon>
                      </div>
                      <p v-if="!isPdfFile(item) && item.cover_photo_uri && item.type !== 'event_info' && contentDisplay(item)" class="compound-text" style="overflow: hidden;" v-html="contentDisplay(item)"></p>
                      <div class="header" v-if="item.rrule_parsed_date && item.type!='event_info'">
                        <timeago v-if="section != 'journal' && section != 'group'" :since="item.rrule_parsed_date" style="display:block;color: #9a9a9a;margin-top:-2px;font-size:9px"></timeago>
                      </div>
                      <!-- <div class="header" style="margin-top: 5px;">
                        <small @click="viewActivity(item)" v-if="titlePreview(item) == item.careplan.title">
                          //<p v-if="section != 'journal' && section != 'group'" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden; font-size: 0.9em">{{item.careplan.title}}</p>
                          <timeago v-if="section != 'journal' && section != 'group'" :since="item.updated_at" style="display:block;color: #9a9a9a;margin-top:-2px;font-size:9px"></timeago>
                        </small>
                      </div> -->

                      <!-- <small style="color: #9a9a9a"  v-if="item.rrule_parsed_date"><timeago v-if="section == 'journal' || section == 'group'" :since="item.rrule_parsed_date"></timeago> -->
                      <span v-if="isModeration" v-on:click="reRouteUserModeration($event, item.poster.id)" ><b> · {{item.poster.display_name}}</b></span></small>
                      <div class="feed-actions" style="position: relative; bottom: 0px;" v-if="item.activity_count > 0 && item.type!='event_info'">
                        <router-link style="font-size: 60%;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + item.id">
                          <i class="far fa-comment"></i>&nbsp;
                          <span style="font-style: strong;" class="comment-number">
                            {{ (item.activity_count > 0) ? item.activity_count : ''}}
                          </span>
                          <span v-if="item.activity_count == 1">Comment</span>
                          <span v-if="item.activity_count > 1">Comments</span>
                        </router-link>

                        <router-link v-show="item.like_count>0" style="font-size: 60%;color:rgb(170, 170, 170);margin-left:10px;" tag="span" :to="'/feed/' + item.id">
                          <i class="far fa-thumbs-up"></i>&nbsp;
                          <span style="font-style: strong;" class="comment-number">
                            {{ (item.like_count > 0) ? item.like_count : ''}}
                          <span> {{ (item.like_count==1) ? 'Like': 'Likes' }} </span>
                          </span>
                        </router-link>

                        <!-- &nbsp;&nbsp;<span style="font-size: 60%;color:rgb(170, 170, 170);" v-if="isShareableCapable()" @click="share(item)"><i class="fas fa-share-alt"></i>&nbsp;Share</span> -->
                      </div>

                      <div v-if="item.data && item.data.pdf">
                        <div class="pdf-item" @click="$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: `Course view pdf`});openPdf(item.data.pdf)">
                          <div v-if="!item.thumbnail_photo_uri" class="pdf-img" :style="{'background-image': `url(${pdfIcon}`}">
                            <!-- PDF -->
                          </div>
                          <img v-else class="pdf-img" :src="getImageActivity(item)">
                          <div class="pdf-text-info">
                            <b style="font-family: inherit;font-size: 14px;">{{ item.title }}</b>
                            <p style="font-family: inherit;font-size: inherit;" class="truncate-two">
                              {{ contentDisplay(item) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- media on the left -->
                    <!-- <div class="image" :style="{background: 'url('+ postPreviewImage(item) +')'}" @click="viewActivity(item)" v-if="item.cover_photo_uri && item.type!='event_info'">
                      <span class="feed-icons">
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'trivia' && item.data.mode == 'poll'" :src="barIcon" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
                      </span>
                    </div> -->
                    <!-- <youtube
                      v-if="item.type == 'attachment' && item.data.attachment_type === 'video' && isYoutubeVideo(item)"
                      :video-id="getVideoId(item.data)"
                      :player-height="250"
                      player-width="100%"
                      style="width: 100%">
                    </youtube> -->
                    <video-player
                      :class="'element-id-' + item.id"
                      style="padding: 0 8px"
                      :id="'PLAYER'+item.id.split('-')[0]"
                      v-if="item.type == 'attachment' && item.data.attachment_type === 'video'"
                      :src="item.data.url || item.data.video"
                      :poster="postPreviewImage(item)"
                      :elementId="item.id"
                      @play="onPlayVideo"
                      @pause="onPauseVideo"
                      @mounted="addVideo"/>
                    <video-player
                      :class="'element-id-' + item.id"
                      style="padding: 0 8px"
                      :id="'PLAYER'+item.id.split('-')[0]"
                      v-else-if="item.type == 'video'"
                      :src="item.data.video"
                      :poster="postPreviewImage(item)"
                      :elementId="item.id"
                      @play="onPlayVideo"
                      @pause="onPauseVideo"
                      @mounted="addVideo"/>
                    <!-- <progressive-img
                      :src="postPreviewImage(item)"
                      v-else-if="item.cover_photo_uri && item.type != 'event_info'"/> -->
                    <Row v-if="item.type == 'event_info' && item.data && item.data.event_start_date" style="float:right;textAlign:center;padding:5px 5px 5px 15px;height:100%;width: 60px;lineHeight:1;display: grid;">
                      <div style="vertical-align: baseline;color:red;vertical-align:middle;font-size: 12px;margin: auto">{{getMonthEvent(item.data.event_start_date)}}</div>
                      <div style="vertical-align: middle;font-size: 33px; margin:auto">{{getDayEvent(item.data.event_start_date)}}</div>
                      <div style="vertical-align: middle;font-size: 10px; margin:auto">{{getYearEvent(item.data.event_start_date)}}</div>
                    </Row>
                  </div>

                <!-- <Card shadow :style="{borderRadius: '0', marginTop: '10px'}" :padding="0" v-if="k == 2 && recentUsers && isFeed == 'HomePage'">
                  <div class="recent-users-holder">
                    <div class="header">
                      <small style="color: rgb(170, 170, 170);padding-left:8px"><b>Latest Members</b></small>
                    </div>
                    <div class="users">
                      <div class="user" v-for="(user, indx) in recentUsers.subscribers" :key="indx" v-on:click="reRouteUser(user.id)" v-if="profileInfo.id != user.id">
                        <Avatar icon="person" :src="user.avatar" size="large" style="width:60px;height:60px;border-radius:100%" />
                        <p class="truncate" style="padding: 0 10px;margin-top: 5px; font-size: 0.8em;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;">
                          <span>{{user.first_name}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Card> -->

                <!-- <Card shadow :style="{borderRadius: '0'}" :padding="0" v-if="!(k % 2)">
                  <div class="card-holder reverse">
                    <div class="feed-details">
                      <div class="header" style="margin-bottom: 5px;">
                        <a @click="viewResource(item)"><Avatar shape="square" size="default" :src="posterPreviewImage(item)" :style="{float:'left', marginRight: '10px'}" /></a>
                        <small @click="viewActivity(item)">
                          <p @click="viewResource(item)" v-if="section != 'journal' && section != 'group'" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;">
                          {{item.careplan.title}}</p>
                          <timeago :since="item.updated_at" style="color: #9a9a9a;"></timeago>
                        </small>
                      </div>
                      <small><b style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;">{{titlePreview(item)}}</b></small>
                      <div class="feed-actions" style="position: absolute;bottom: 5px;">
                        <router-link style="font-size: 80%;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + item.id + '?scroll=true'"><i class="far fa-comment"></i>&nbsp;
                          Comments {{ (item.activity_count > 0) ? item.activity_count : ''}}</router-link>
                          &nbsp;&nbsp;<span style="font-size: 80%;color:rgb(170, 170, 170);" v-if="isShareableCapable()" @click="share(item)"><i class="fas fa-share-alt"></i>&nbsp;Share</span>
                      </div>
                    </div>
                    <div class="image" :style="{background: 'url('+ postPreviewImage(item) +')'}" @click="viewActivity(item)" v-if="item.cover_photo">
                      <span class="feed-icons">
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'trivia' && item.data.mode == 'poll'" icon="pie-graph" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar>
                        <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
                      </span>
                    </div>
                  </div>
                </Card> -->

                <Card shadow :style="{borderRadius: '0'}" :padding="0" v-if="false">
                    <div class="feed-header" :style="{marginBottom: '10px', padding: '10px 10px 8px'}">
                        <Dropdown placement="bottom-end" style="float:right; padding-right:10px;" v-if="$store.state.user.info.user_type !== 'guest'">
                          <img alt=" " v-if="item.bookmarked" src="@/assets/icons8-bookmark-filled-50.png" style="height:12px;width:14px;margin-right:10px;">
                          <a style="padding:4px 0px; color: black;">
                            <Icon size="20" type="android-more-vertical"></Icon>
                          </a>
                          <DropdownMenu slot="list">
                            <DropdownItem v-if="item.poster && item.poster.id == profileInfo.id">
                              <a @click="deleteItem(item.id, item)">Delete</a>
                            </DropdownItem>
                            <DropdownItem>
                              <a @click="bookmarkItem(item)">{{ (item.bookmarked) ? 'Unbookmark':'Bookmark' }}</a>
                            </DropdownItem>
                            <DropdownItem>
                              <a @click="showReport(item.id)">Report this post</a>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                        <!-- <span v-if="item.poster && item.poster.id == profileInfo.id" style="position:absolute;right:10px">
                          <Poptip v-model="proptip[item.id]" placement="left">
                            <template slot="title"></template>
                           <Icon type="android-more-vertical" size="20"></Icon>
                            <div slot="content" class="options-menu">
                              <a @click="deleteItem(item.id, item)">Delete</a>
                            </div>
                          </Poptip>
                        </span> -->
                        <a @click="viewResource(item)"><Avatar shape="square" size="large" :src="posterPreviewImage(item)" :style="{float:'left', marginRight: '10px'}" /></a>
                        <p @click="viewActivity(item)" class="multiline-ellipsis">
                          <b>{{titlePreview(item)}}</b>
                        </p>
                        <small style="color:#aaa">
                           <timeago :since="item.rrule_parsed_date"></timeago>
                           <b @click="viewResource(item)" v-if="section != 'journal' && section != 'group'">
                           &middot; {{item.careplan.title}}</b>
                        </small>
                    </div>
                    <div class="feed-content" style="position:relative">
                        <div @click="viewActivity(item)" class="image-preview-container" v-if="item.cover_photo_uri" style="position:relative">
                          <span style="    line-height: 200px;position: absolute;width: 20px;left: 45%;right: 0px;height: 200px;">
                            <Avatar class="play-icon" v-if="item.type == 'attachment' && item.data.attachment_type == 'video'" icon="play" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                            <!-- <Avatar v-if="item.type == 'trivia' && item.data.mode == 'poll'" icon="pie-graph" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar> -->
                            <Avatar v-if="item.type == 'trivia' && item.data.mode == 'poll'" :src="barIcon" class="feed-icon"></Avatar>
                            <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'slideshow'" icon="images" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                            <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'link'" icon="link" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                          </span>
                          <img :src="postPreviewImage(item)" width="100%" alt="IMAGE">
                        </div>
                        <div style="padding: 8px 10px 0" v-if="item.is_shareable">
                            <SharePost :item="item"></SharePost>
                        </div>
                        <div @click="viewActivity(item)" style="padding: 8px 10px 0;">
                           <p v-if="!isPdfFile(item)" class="compound-text" style="text-align: left;" v-html="contentDisplay(item)"></p>
                        </div>
                    </div>
                    <div class="feed-actions" :style="{padding: '8px 10px 8px'}">
                        <Row>
                            <!--<Col span="12">-->
                              <!--<p align="center" @click="bookmarkItem(item)">-->
                                <!--<span v-if="!item.bookmarked"><i class="far fa-bookmark"></i>&nbsp;Bookmark</span>-->
                                <!--<span v-if="item.bookmarked" style="color:#3f8dff"><i class="fas fa-bookmark"></i>&nbsp;Bookmarked</span>-->
                              <!--</p>-->
                            <!--</Col>-->
                            <Col span="24">
                              <router-link style="font-size:12px;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + item.id"><i class="far fa-comment"></i>&nbsp;
                                Comments {{ (item.activity_count > 0) ? item.activity_count : ''}}</router-link>
                              &nbsp;&nbsp;<span style="font-size:12px;color:rgb(170, 170, 170);" v-if="isShareableCapable()" @click="share(item)"><i class="fas fa-share-alt"></i>&nbsp;Share</span>
                            </Col>
                        </Row>
                    </div>
                </Card>
            </Col>
            <Col :span="24" :style="{background: (isInfo) ? 'transparent':'white'}" v-if="orderedFeeds && orderedFeeds.length > 0">
              <Row type="flex" justify="center" align="top">
                <img alt=" " src="@/assets/end-comment.png" width="80px" height="40px" style="margin-top:-5px">
              </Row>
            </Col>
            <Col v-if="false && isLoadMoreShow && !groupFeedLoader" style="margin-bottom:13px" span="24">
                <Button style="width:50%;display:flex;margin: 0 auto;justify-content:center;backgroundColor:white" @click="loadMoreItems" default :loading="!isLoadMoreTextShow">
                  <span v-if="isLoadMoreTextShow" style="color:#2d8cf0">Load More</span>
                  <span v-else>Loading...</span>
                </Button>
              <!-- <Card shadow :style="{borderRadius: '0',display: 'flex', justifyContent: 'center'}" :padding="7">
                <span @click="loadMoreItems" v-if="isLoadMoreTextShow">Load More</span>
                <Spin v-if="!isLoadMoreTextShow">
                  <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                </Spin>
              </Card> -->
              <!-- <Spin>
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
              </Spin> -->
            </Col>
            <!-- <Col :span="24" style="background: #fff; height: 130px;padding: 0px;" v-if="isLoading">
              <vue-content-loading :width="300" :height="121" style="height: 100%">
                <rect x="0" y="0" rx="0" ry="0" width="130" height="130" />
                <rect x="136" y="12" rx="4" ry="4" width="100" height="16" />
                <rect x="136" y="37" rx="4" ry="4" width="50" height="10" />
              </vue-content-loading>
            </Col> -->
            <Col :span="24" v-if="orderedFeeds && orderedFeeds.length <= 0 && !isLoading">
              <p align="center" style="padding:20px;background: #fff; color:#aaa">No activity to show</p>
            </Col>
            <!-- <Col :span="24" v-if="feed.isLoading && !isPublic">
              <Spin style="margin: 20px 0;">
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
              </Spin>
            </Col> -->
        </Row>
        <ReportComment :itemtype="'activity'" :activityid="activityid"></ReportComment>
    </div>
</template>

<script>
const mime = require('mime')
import Utils from '@/utils.js'
import _ from 'lodash'
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import VuerMixin from '@/helpers/vuerMixin'
import SharePost from '@/components/SharePostComponent'
import CourseComponent from '@/components/CourseComponent'
import ReportComment from '@/components/ReportComponent';
import VueContentLoading from 'vue-content-loading';
import { Message,Modal } from 'iview'
import { mapGetters } from 'vuex'
import VideoPlayerComponent from '@/components/VideoPlayerComponent'
import ActivityDropdownContext from '@/components/ActivityDropdownContext'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import pdfLogo from '@/assets/pdf/PDF_file_icon.png'

export default {
  name: 'CourseListComponent',
  mixins: [WindowScrollEvent, VuerMixin],
  components: {
    SharePost, ReportComment, VueContentLoading, CourseComponent, ActivityDropdownContext
  },
  data() {
    return {
      readingCounter: null,
      readingDuration: 0,
      sticky: false,
      proptip: [],
      activityid:'',
      Utils,
      isLoadMoreShow:false,
      isLoadMoreTextShow:true,
      groupID: Cons[0].GROUP_ID,
      videoPlayers: [],
      showSinglePreview: false,
      isSinglePreviewLoading: false,
      singlePreviewItemId: null,
      singleFeedItem: null,
      singleFeedPromise: null,
      currentlyPlaying: null,
      courseIdleDuration: {
        startTime:'',
        endTime:'',
        timeDuration:''
      }
    }
  },
  props: {
    isInfo: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Boolean,
      default: false
    },
    isPublic: {
      type: Boolean,
      default: false
    },
    section: {
      type: String,
      required: true,
      default: 'none'
    },
    isAdmin: {
      type: [Boolean, String],
      required: false,
      default: ''
    },
    isModeration: {
      type: [Boolean, String],
      required: false,
      default: ''
    },
    pSingleFeedItem: {
      type: Object,
      required: false,
      default: null
    },
    items: {
      type: [Object, Array],
      required: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy(){
    let newDate = new Date();
    newDate = newDate.getTime();
    
    this.courseIdleDuration.endTime = newDate ////milliseconds
    this.courseIdleDuration.timeDuration = Math.floor((this.courseIdleDuration.endTime - this.courseIdleDuration.startTime)/1000)

    this.endReading();

    //do something here Course Time!!!
    let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
    this.$store.dispatch("points/setUserActionPoints", {
      action: "module_visit",
      duration: this.readingDuration,
      user_story_id: engageCourse.userStory,
      track_id: engageCourse.course,
      module_id: engageCourse.article,
      category: engageCourse.category
    }, {root: 1})

    if(this.currentlyPlaying){
      this.currentlyPlaying = {
        ...this.currentlyPlaying, 
        ...{src:this.currentlyPlaying.src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
      }
    }
      console.log('this.currentlyPlaying 3',this.currentlyPlaying);
      //do something here Video Time!!!!
      let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
      this.$store.dispatch("points/setUserActionPoints", {
        action: "watch_video",
        video_link: this.currentlyPlaying.src,
        duration: this.currentlyPlaying.timeDuration,
        user_story_id: engageCourse.userStory,
        element_id: this.currentlyPlaying.element_id,
        track_id: engageCourse.course,
        module_id: engageCourse.article,
        category: engageCourse.category
      }, {root: 1})
      this.currentlyPlaying = null;
    }
  },
  mounted() {
    this.initAudioListener()

    if(  this.$route.path === '/home' )
      this.$store.dispatch('feed/getFeaturedUsers');
    this.applyUpcommingToFeed()

    setTimeout(() => {
      this.mountVideoLoaders()
    },400),

    setTimeout(() => {
      this.mountActivityRedirectLinks()
      this.mountZoomableImages()
      this.mountVideoPlayers()
      this.mountPdfLinks()
    }, 1500);

    let newDate = new Date();
    newDate = newDate.getTime();
    this.courseIdleDuration.startTime = newDate ////milliseconds

    this.startReading();
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    openPdf(pdfUrl) {
      this.$router.push(`/feed/pdf?src=${pdfUrl}`)
    },
    handleScroll(){
      // videos
      var videos = document.querySelectorAll('.player-container .video-js video')
      if (!videos) return

      for (var i = 0; i < videos.length; i++) {
        var position = videos[i].getBoundingClientRect();
        // checking for partial visibility
        if( -(videos[i].offsetHeight / 4) > position.top || position.bottom >= window.innerHeight+(videos[i].offsetHeight / 4)) {
          if (videos[i].paused) {}
          else{
            videos[i].pause();
          }
        }
      }

      // youtube
      var embedVideos = document.querySelectorAll('.ql-editor-video .player-container .video-js')
      if (!embedVideos) return

      for (var i = 0; i < embedVideos.length; i++) {
        var position = embedVideos[i].getBoundingClientRect();
        // checking for partial visibility
        if( -(embedVideos[i].offsetHeight / 4) > position.top || position.bottom >= window.innerHeight+(embedVideos[i].offsetHeight / 4)) {
          if (this.currentlyPlaying && this.currentlyPlaying.videoplayer.id_.replace('QUILL-PLAYER-', '') == i) {
            this.currentlyPlaying.videoplayer.pause();
            this.onPauseVideo(this.currentlyPlaying.videoplayer,this.currentlyPlaying.src,this.currentlyPlaying.element_id)            
          }
        }
      }
    },
    tocTitleStyle(index) {
      if (index > this.orderedFeeds.length) return {}
      return {
        position: this.showContextMenu(this.orderedFeeds[index]) && !this.broadcastOnly ? 'absolute' : 'unset',
        zIndex: this.showContextMenu(this.orderedFeeds[index]) && !this.broadcastOnly ? 2 : 1,
        top: this.showContextMenu(this.orderedFeeds[index]) && !this.broadcastOnly ? '18px' : '0px'
      }
    },
    showContextMenu(activityElement) {
        console.log(_.get(activityElement, "type"), _.get(activityElement, "data.attachment_type"))
        if( _.get(activityElement, "type") == 'video' || _.get(activityElement, "type") == 'image') 
            return true;            
        if( _.get(activityElement, "type") == 'attachment') 
            if( _.get(activityElement, "data.attachment_type") == 'video' || _.get(activityElement, "data.attachment_type") == 'image') 
                return true;            
        if( _.get(activityElement, "tags") ) {
            let findImage = _.get(activityElement, "tags").indexOf('sys_image')
            let findVideo = _.get(activityElement, "tags").indexOf('sys_video')
            if( findVideo >= 0 ||  findImage >= 0)
                return true;
            return false;
        }
        return false;
    },
    scrollToTop() {
      // document.getElementById("toc").scrollIntoView({ behavior: "smooth" })
      const yOffset = -150; 
      const element = document.getElementById("toc");
      const y = 0 + yOffset
      window.scrollTo({top: y, behavior: 'smooth'});

      //get and remove all element highlight
      // var highlighted = document.getElementsByClassName("highlight")
      
      // for (var i = 0; i < highlighted.length; i++) {
      //   highlighted[i].classList.remove("highlight")
      // }
    },
    titleFormat(text) {
      return _.kebabCase(text)
    },
    startReading() {
      if(this.readingCounter) return false;
      
      this.readingCounter = setInterval(()=> {
        this.readingDuration += 1;
      }, 1000)
    },
    endReading() {
      clearInterval(this.readingCounter);
      this.readingCounter = null;
    },
    mountActivityRedirectLinks(){
      var thisComponent = this
      var anchors = thisComponent.$el.querySelectorAll('.compound-text > p > a')

      for (let anchor of anchors){
        if (this.isGuid(anchor.getAttribute('href')) && anchor.classList.contains('action_link-goto')){
          anchor.addEventListener("click", e => {
            e.preventDefault();

            if (anchor.classList.contains('link_type-post_id'))
              this.$router.push("/feed/" + anchor.getAttribute('href'))
            else if (anchor.classList.contains('link_type-module_id'))
              this.$router.push("/module/" + anchor.getAttribute('href'))
            else if (anchor.classList.contains('link_type-element_id'))
              this.$router.push("/feed/" + anchor.getAttribute('href'))
          });
        }
        else if (this.isGuid(anchor.getAttribute('href')) && anchor.classList.contains('action_link-popup')) {
          anchor.addEventListener('click', (e)=> {
            e.preventDefault()
            this.showSinglePreview = true
            this.singlePreviewItemId = anchor.getAttribute('href')
            this.loadSingleFeedItem()
          })
        }
        else if (!this.isGuid(anchor.getAttribute('href')) && anchor.classList.contains('action_link-popup')) {
          anchor.addEventListener('click', (e)=> {
            e.preventDefault()
            this.showSinglePreview = true
            this.singlePreviewItemId = anchor.getAttribute('href')
          })
        }
      }
    },
    mountZoomableImages(){
      var thisComponent = this
      var zoomableParent = thisComponent.$el.querySelectorAll('.ql-editor-full-width > img')
      for (let element of zoomableParent)
      {
        let img = element
        element.classList.add('pointer')     

        var classListSample = img.parentElement.parentElement.parentElement.parentElement.parentElement.classList
        var elId=''
        for (let index = 0; index < classListSample.length; index++) {
          const element = classListSample[index];
          if(element.includes('element-id')){
            elId = element.replace('element-id-', '')
          }
        }

        img.onclick = function(event) {
          let src = img.currentSrc
          img = new Image()
          img.src = src.replace('/large/','/original/')
          thisComponent.showVuerSingleElement(event, img)
          console.log(elId);
          //do something Image
          let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
          thisComponent.$store.dispatch("points/setUserActionPoints", {
            action: "view_image",
            user_story_id: engageCourse.userStory,
            track_id: engageCourse.course,
            module_id: engageCourse.article,
            category: engageCourse.category,
            element_id: elId
          }, { root: 1 });

          if(thisComponent.currentlyPlaying){
            thisComponent.currentlyPlaying.videoplayer.pause();
            thisComponent.onPauseVideo(thisComponent.currentlyPlaying.videoplayer,thisComponent.currentlyPlaying.src,thisComponent.currentlyPlaying.element_id)
          }
        }
      }
    },
    mountVideoLoaders() {
      let videosWithImg = this.$el.querySelectorAll('.ql-editor-video > img')
      if (!videosWithImg) return

      for (var i = 0; i < videosWithImg.length; i++) {
        let videoImg = videosWithImg[i]

        videoImg.parentElement.parentElement.classList.add("p-relative")

        let loadingNode = document.createElement('div')
        loadingNode.classList.add("video-loader")
        let loader = document.createElement("i")
        loadingNode.appendChild(loader)
        loader.classList.add("fa")
        loader.classList.add("fa-spin")
        loader.classList.add("fa-spinner")
        videoImg.parentElement.appendChild(loadingNode) 
      }
    },
    mountPdfLinks() {
      setTimeout(() => {
        let thisComponent = this
        var pdfLinks = thisComponent.$el.querySelectorAll('.-ql-pdf-link')
        for (let pdfLink of pdfLinks) {
          pdfLink.addEventListener("click", (e) => {
            e.preventDefault();
            thisComponent.openPdf(pdfLink.href)
          });
        }
      }, 10)
    },
    mountVideoPlayers(){
      let thisComponent = this
      var videosWithImg = thisComponent.$el.querySelectorAll('.ql-editor-video > img')

      if (!videosWithImg) return

      for (var i = 0; i < videosWithImg.length; i++) {
        var videoImg = videosWithImg[i]
        var videoSrc = ''
        var poster = ''

        var videoSrc = videoImg.parentElement.classList[2].replace('src-', '')
        for (let index = 3; index < videoImg.parentElement.classList.length; index++) {
          if(!videoImg.parentElement.classList[index].startsWith("img-")){
              videoSrc += `+${videoImg.parentElement.classList[index]}`;
          }else{
              poster = videoImg.parentElement.classList[index].replace('img-', '')
              break;
            }
        }

        var isYoutubeVideo = Utils.validateYouTubeUrl(videoSrc)
        var classListSample = videoImg.parentElement.parentElement.parentElement.parentElement.parentElement.classList
        var elId=''
        for (let index = 0; index < classListSample.length; index++) {
          const element = classListSample[index];
          if(element.includes('element-id')){
            elId = element.replace('element-id-', '')
          }
        }
        var VideoPlayerClass = Vue.extend(VideoPlayerComponent)
        var instance = new VideoPlayerClass({
          propsData: {
            id: 'QUILL-PLAYER-' + i,
            src: videoSrc,
            poster: poster,
            disabled: this.isEditMode,
            elementId: elId
          }
        })

        instance.$on('mounted', (e) => {
          this.addVideo(e)
        })

        instance.$on('pause', (e,src,id) =>{
          let newDate = new Date();
          newDate = newDate.getTime();

          this.endReading();
          
          if(this.currentlyPlaying && src == this.currentlyPlaying.src && e == this.currentlyPlaying.videoplayer){
            this.currentlyPlaying = {
              ...this.currentlyPlaying, 
              ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000),element_id:id
            }
          }
            console.log('this.currentlyPlaying 2',this.currentlyPlaying);
            //do something here Video Time!!!!
            let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
            this.$store.dispatch("points/setUserActionPoints", {
              action: "watch_video",
              video_link: this.currentlyPlaying.src,
              duration: this.currentlyPlaying.timeDuration,
              user_story_id: engageCourse.userStory,
              element_id: this.currentlyPlaying.element_id,
              track_id: engageCourse.course,
              module_id: engageCourse.article,
              category: engageCourse.category
            }, {root: 1})

            this.currentlyPlaying = null;
            this.startReading();
          }
        })

        instance.$on('play', (e,src,id) => {
          this.elementIdFocus = id;
          let newDate = new Date();
          newDate = newDate.getTime();

          this.endReading();

          if(this.currentlyPlaying){
            this.currentlyPlaying = {
              ...this.currentlyPlaying, 
              ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
            }
            }
            //do something here Video Time!!!!
            console.log('this.currentlyPlaying 5',this.currentlyPlaying);
            let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
            this.$store.dispatch("points/setUserActionPoints", {
              action: "watch_video",
              video_link: this.currentlyPlaying.src,
              duration: this.currentlyPlaying.timeDuration,
              user_story_id: engageCourse.userStory,
              element_id: this.currentlyPlaying.element_id,
              track_id: engageCourse.course,
              module_id: engageCourse.article,
              category: engageCourse.category
            }, {root: 1})
            this.currentlyPlaying = null;

            this.startReading();
          }

          this.currentlyPlaying = {videoplayer:e,src,playTime:newDate, element_id:id}
          this.pauseVideoExcept(e)
        })

        instance.$mount()

        videoImg.parentElement.appendChild(instance.$el)

        // remove dummy video loaders
        let loadingNode = videoImg.parentElement.children[1]
        loadingNode.remove()
        
        videoImg.remove()
      }
    },
    async loadSingleFeedItem(){
      this.isSinglePreviewLoading = true
      try {
        let res = await this.$store.dispatch('feed/getSingleItem', this.singlePreviewItemId);
        this.singleFeedItem = res.data;
      } catch(e) {
        console.log(e)
      } finally {
        this.isSinglePreviewLoading = false
      }

      // this.singleFeedPromise = this.$store
      //   .dispatch('feed/getSingleItem', this.singlePreviewItemId)
      //   .then(res => {
      //     this.isSinglePreviewLoading = false
      //     res.data = this.singleFeedItem
      //   })
      //   .catch(err => {
      //     this.isSinglePreviewLoading = false
      //   })
    },
    onPlayVideo(v,src,id){
      let newDate = new Date();
      newDate = newDate.getTime();

      this.endReading();

      if(this.currentlyPlaying){
        this.currentlyPlaying = {
          ...this.currentlyPlaying, 
          ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000)
        }
      }
        //do something here Video Time!!!!
        console.log('this.currentlyPlaying 4',this.currentlyPlaying);
        let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: this.currentlyPlaying.element_id, link_tag: `Playing course video`});
        this.$store.dispatch("points/setUserActionPoints", {
          action: "watch_video",
          video_link: this.currentlyPlaying.src,
          duration: this.currentlyPlaying.timeDuration,
          user_story_id: engageCourse.userStory,
          element_id: this.currentlyPlaying.element_id,
          track_id: engageCourse.course,
          module_id: engageCourse.article,
          category: engageCourse.category
        }, {root: 1})
        this.currentlyPlaying = null;
        this.startReading();
      }
      this.currentlyPlaying = {videoplayer:v,src,playTime:newDate, element_id:id}
      this.pauseVideoExcept(v);
    },
    onPauseVideo(v,src,id){
      let newDate = new Date();
      newDate = newDate.getTime();

      this.endReading();

      if(this.currentlyPlaying && src == this.currentlyPlaying.src && v == this.currentlyPlaying.videoplayer){
        this.currentlyPlaying = {
          ...this.currentlyPlaying, 
          ...{src, pauseTime: newDate, timeDuration: Math.floor((newDate - this.currentlyPlaying.playTime)/1000), element_id:id
        }
      }
      //do something here Video Time!!!!
      let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
      this.$store.dispatch("points/setUserActionPoints", {
        action: "watch_video",
        video_link: this.currentlyPlaying.src,
        duration: this.currentlyPlaying.timeDuration,
        user_story_id: engageCourse.userStory,
        element_id: this.currentlyPlaying.element_id,
        track_id: engageCourse.course,
        module_id: engageCourse.article,
        category: engageCourse.category
      }, {root: 1})
      console.log('this.currentlyPlaying 1',this.currentlyPlaying);
      this.currentlyPlaying = null;
      this.startReading();
      }
    },
    pauseVideoExcept(video, playAudio){
      if(!playAudio){
        this.pauseAllAudio();
      }

      this.videoPlayers.forEach(videoPlayer => {
        if (videoPlayer !== video){
          videoPlayer.pause()
        }
      })
    },
    pauseAllAudio(){
      var audios = document.getElementsByTagName('audio');
      for(var i = 0, len = audios.length; i < len;i++){
          audios[i].currentTime = 0
          audios[i].pause();
      }
    },
    initAudioListener(){
      document.addEventListener('play', (e) => {
        if(e.target && e.target.tagName == 'AUDIO'){
          this.pauseVideoExcept(null, true)
        }
      }, true);
    },
    addVideo(video){
      this.videoPlayers.push(video)
    },
    isGuid(str) {
      if (str[0] === "{")
        {
          str = str.substring(1, str.length - 1);
        }
      // var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
      // var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      var regexGuid = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/g
      return regexGuid.test(str);
		},
    isYoutubeVideo(item){
      return item.data.hasOwnProperty('video') ? Utils.validateYouTubeUrl(item.data.video) : Utils.validateYouTubeUrl(item.data.url)
    },
    getVideoId(url) {
      if(url.url){
        console.log('from url');

        return this.$youtube.getIdFromURL(url.url);
      }else if(url.video){
        console.log('from video');
        return this.$youtube.getIdFromURL(url.video);
      }
    },
    removeHTMLTags (data){
        if(data)
          return data.replace(/<\/?[^>]+(>|$)/g, "");
    },
    getMonthEvent(date) {
        if(date){
          return Utils.parseDateToMonth(new Date(date))
        }else{
          return ""
        }
    },
    getDayEvent(date){
        if(date){
          return Utils.parseDateToDay(new Date(date))
        }else{
          return ""
        }
    },
    getYearEvent(date){
        if(date){
          return Utils.parseDateToYear(new Date(date))
        }else{
          return ""
        }
    },
    copyToClipboard(item) {
      if (this.feedItem && this.feedItem.cover_photo) {
        navigator.clipboard.writeText(this.postPreviewImage(item, true))
        .then(() => {
          Message.info("Image copied to clipboard");
        })
        .catch(err => {
          Message.error('Could not copy text: ', err);
        })
      }
    },
    change(s) {
      this.sticky = s
    },
    applyUpcommingToFeed() {
      window.scrollTo({top:0})
      this.$store.commit('user/applyUpcommingToFeed');
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    },
    showReport: function(activityid) {
      this.activityid=activityid;
      this.$store.commit('user/setReportThisId', activityid);
      this.$store.commit('user/setShowStepsActivity', true);
    },
    confirmDelete(id) {
      this.$store.dispatch('user/deleteItem', id)
        .then(r => {
          for( let x=0;x<this.feed.list.careplan_item.length; x++) {
            if (this.feed.list.careplan_item[x].id == id) {
              this.feed.list.careplan_item.splice(x, 1);
              break;
            }
          }
        })
    },
    confirmDeletePendingItem(id) {
      this.$store.dispatch('resource/removePendingItem', id)
        .then(r => {
          this.$Message({
            closable: true,
            // durationInSec:3,
            title: { content:'Success' },
            icon: 'alert',
            message: { content: 'Successfully Deleted' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=>{
                  for( let x=0;x<this.feed.list.careplan_item.length; x++) {
                    if (this.feed.list.careplan_item[x].id == id) {
                      this.feed.list.careplan_item.splice(x, 1);
                      break;
                    }
                  }
                }
              }
            ]
          });
        })
    },
    deleteItem(id, item) {
      event.stopPropagation();
      this.closeProptip(id);

      this.$Message({
        closable: true,
        title: { content:'Delete Post' },
        icon: 'ios-trash',
        message: { content: 'Are you sure you want to delete this post?' },
        buttons: [
          { label: 'Yes', type: 'error', hideAfter:true, action: ()=> {
              if (this.isModeration){
                this.confirmDeletePendingItem(id)
              }else{
                this.confirmDelete(id)
              }
            }
          },
          { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });
    },
    approveItem(event,item) {
      event.stopPropagation();
      console.log(item);

      this.$store.dispatch('resource/approvePendingItem', item)
        .then(r => {
          this.$Message({
            closable: true,
            // durationInSec:3,
            title: { content:'Success' },
            icon: 'alert',
            message: { content: 'Successfully Posted' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=>{
                for( let x=0;x<this.feed.list.careplan_item.length; x++) {
                    if (this.feed.list.careplan_item[x].id == item.id) {
                      this.feed.list.careplan_item.splice(x, 1);
                      break;
                    }
                  }
                }
              }
            ]
          });
        })
    },
    isShareableCapable() {
      return (!navigator.share) ? false : true;
    },
    closeProptip(id) {
      this.proptip[id] = false
    },
    share(act) {
      let desc = '';
      switch (act.type) {
        case "user_post":
          desc = act.data.text;
          break;
        case "attachment":
          desc = act.data.text;
          break;
        case "trivia":
          desc = act.data.text;
          break;
        case "reveal":
          desc = act.data.question;
          break;
        default:
          desc = act.data.tip.replace(/(<([^>]+)>)/gi, '')
          break;
      }

      navigator.share({
        title: act.title,
        text: desc,
        url: act.data.page_url // `${process.env.VUE_APP_SITE}/${process.env.VUE_APP_DEV_ECOSYSTEM}/feed/${act.id}`
      }).then(() => {
        this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: act.id, link_tag: `Course share activity`});
        this.$notice.info('Shared Successfully')
      }).catch(error => {
        this.$notice.error('Please try again later.')
      });
    },
    postType(act) {
        switch (act.type) {
            case "attachment":
                if(act.data) {
                    switch (act.data.attachment_type) {
                        case "video":
                            return 'Video Link';
                            break;
                        case "link":
                            return 'URL';
                            break;
                        case "slideshow":
                            return 'Slideshow';
                            break;
                        case "image":
                            return 'Image';
                            break;
                    }
                }
                break;
            case "trivia":
                if(act.data) {
                    switch (act.data.mode) {
                        case "true_or_false":
                            return 'TOF';
                            break;
                        case "checklist":
                            return 'Checklist';
                            break;
                        case 'multiple':
                            return 'Multiple Choice';
                            break;
                        case 'poll':
                            return 'Poll';
                            break;
                    }
                }
                break;
            case "reveal":
                return 'Question & Answer';
                break;
            case "recipe":
                return 'Recipe';
                break;
            case "apply_volunteer":
                var txt = '';
                if (act.data.permission == 503) txt = 'Admin'
                else if (act.data.permission == 99) txt = 'Moderator'
                else if (act.data.permission == 49) txt = 'Editor'
                else if (act.data.permission == 16) txt = 'Author'
                else if (act.data.permission == 1) txt = 'Member'
                return 'Applying for ' + txt + ':';
                break;
            default:
                return 'Article';
                break;
        }
    },
    bookmarkItem (item) {
      if( this.profileInfo.user_type !== 'guest') {
        this.$store.dispatch('feed/bookmarkItem', {item, type: this.section}).then(res => {
          this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: `Bookmark course item`});
          if (!item.bookmarked) {
            item.bookmark_id = res.id
            item.bookmarked = 1
          } else {
            delete item.bookmark_id
            item.bookmarked = 0
          }
        }, err => {})
      } else {
        this.$store.commit('hitCheckpoint');
      }
    },
    viewActivity (item) {
      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: `View course activity`});
      if(item.careplan && item.type == "event_info" && this.isFeed == 'HomePage'){
        this.viewResource(item)
      }else{
        if(this.isPublic) return false;
        this.$store.commit('feed/setSingleFeed', item)
        if(this.isAdmin){
          this.$router.push({ path: '/feed/' + item.id + "?scroll=false" , query:{isAdmin:this.isAdmin}})
        }else{
          this.$router.push({ path: '/feed/' + item.id + "?scroll=false"})
        }
      }
    },
    viewResource (item) {
      if(this.isPublic) return false;
      var id =  item.careplan.id
      if(item.type == 'event_info' && item.data && item.data.group_id){
        id = item.data.group_id
      }

      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: id, link_tag: `View course activity`});

      if (this.section == 'journal' && this.section == 'group') { console.log('test') } else {
        if(item.type == "event_info"){
          this.$router.push({path: '/resources/' + id , query:{type:'event'}})
        }else{
          this.$router.push({ path: '/resources/' + id })}
        }
    },
    reRouteUser (id) {
      this.$router.push({ path: '/profile/' + id })
      // this.$router.push('profile/' + id )
    },
    reRouteUserModeration(event,id){
      event.stopPropagation();
      this.$router.push({ path: '/profile/' + id })
    },
    titlePreview (item) {
      // if (this.section == 'journal' || this.section == 'group')
      // { return item.poster.display_name

      //  } else { return item.title }
      return item.title
    },
    posterPreviewImage (item) {
      if (this.section == 'journal') {
        return item.poster.avatar
      } else if (this.section == 'group') {
        return item.poster.avatar
      } else {
        return Utils.getDisplayImage('group', item.careplan, 'small')
      }
    },
    contentDisplay (act) {
      switch (act.type) {
        case 'user_post':
          if (act.data) return act.data.text
          break
        case 'passport_expiration':
          return 'Passport Expiration'
          break
        case 'contract_expiration':
          return 'Contract Expiration'
          break
        case 'attachment':
          if (act.data) {
            switch (act.data.attachment_type) {
              case 'video':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              case 'link':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              default:
                if (act.data.text) return act.data.text
                break
            }
          }
          break
        case 'trivia':
          if (act.data && act.data.question) return act.data.question
          break
        case 'reveal':
          if (act.data && act.data.question) return act.data.question
          break
        case 'recipe':
          if (act.data && act.data.description) { return '<a>View Recipe</a>' }
          break
        case 'event_info':
          if (act.data && act.data.description) { return act.data.description }
          break
        case 'video':
          if (act.data && act.data.text) { return act.data.text }
          break
        case 'pdf':
          if (act.data && act.data.text) { return act.data.text }
          break
        default:
          if (act.data && act.data.tip) { return act.data.tip }
          break
      }
      return ''
    },
    postPreviewImage (act) {
      return Utils.getDisplayImage('activity_thumbnail', act, 'large')
    },
    getImageActivity(act){
      return Utils.getDisplayImage('activity_thumbnail', act, 'small')
    },
    onWindowScrolledBottom () {
      setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
      }, 10)
      if (this.section == 'journal') {
        if (this.$store.state.user.feed.list.next_link && !this.$store.state.user.journalFeed.isLoading) {
          this.isLoadMoreShow = true
        }
      } else if (this.section == 'group' && this.isModeration) {
        if (this.$store.state.resource.pendingResources.list.next_link && !this.$store.state.resource.pendingResources.isLoading) {
            this.isLoadMoreShow = true
          }
      } else if (this.section == 'group') {
        if (this.$store.state.resource.groupFeed.list.next_link && !this.$store.state.resource.groupFeed.isLoading) {
            this.isLoadMoreShow = true
          }
      } else {
        if (this.$store.state.user.feed.list.next_link && !this.$store.state.user.feed.isLoading) {
            this.isLoadMoreShow = true
          }
      }
    },
    loadMoreItems(){
      this.isLoadMoreTextShow = false
      if (this.section == 'journal') {
        if (this.$store.state.user.feed.list.next_link && !this.$store.state.user.journalFeed.isLoading) {
          this.$store.dispatch('user/getJournalFeedMore', { url: this.$store.state.user.journalFeed.list.next_link })
          .then(res => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            },error => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            })
        }
      } else if (this.section == 'group' && this.isModeration) {
        if (this.$store.state.resource.pendingResources.list.next_link && !this.$store.state.resource.pendingResources.isLoading) {
            this.$store.dispatch('resource/getPendingResourcesMore', { url: this.$store.state.resource.pendingResources.list.next_link })
            .then(res => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            },error => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            })
          }
      } else if (this.section == 'group') {
        if (this.$store.state.resource.groupFeed.list.next_link && !this.$store.state.resource.groupFeed.isLoading) {
            this.$store.dispatch('resource/getGroupFeedMore', { url: this.$store.state.resource.groupFeed.list.next_link })
            .then(res => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            },error => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            })
          }
      } else {
        if (this.$store.state.user.feed.list.next_link && !this.$store.state.user.feed.isLoading) {
            this.$store.dispatch('user/getUserFeedMore', {url: this.$store.state.user.feed.list.next_link })
            .then(res => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            },error => {
              this.isLoadMoreShow = false
              this.isLoadMoreTextShow = true
            })
          }
      }
    },
    goToPeople(){
        this.$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: `Go to people`});
        this.$router.push({
          path: '/people',
          query:{id:Cons[0].GROUP_ID.donate, section:'Latest'}
        })
    },
    isPodcastFile(item){
      return item.type === 'podcast_object'
        || item.type === 'podcast'
        || (item.type == 'attachment' && item.data.attachment_type == 'podcast')
    },
    isPdfFile(item){
      return item.type === 'pdf' 
        || item.type === 'pdf_object' 
        || (item.type == 'attachment' && item.data.attachment_type == 'pdf')
    }
  },
  computed: {
    ...mapGetters("library", ["trackData"]),
    ...mapGetters("user", ["brandInfo"]),
    broadcastOnly(){
      return _.get(this.brandInfo, "broadcast", 0)
    },
    activityLikes: function() {
      return this.$store.state.feed.activityLikes.data.likes;
    },
    activityLikesCount: function() {
      return Utils.numFormatterToK(this.$store.state.feed.activityLikes.data.likes.length);
    },
    publicProfile: {
      get() {
        return this.$store.state.user.publicProfile;
      }
    },
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    feed: {
      get () {
        return this.trackData.elements || [];
        // return this.$store.state.resource.singleResource.data.pages || []
        // if (this.section == 'journal') {
        //   return this.$store.state.user.journalFeed
        // } else if (this.section == 'group' && this.isModeration) {
        //   return this.$store.state.resource.pendingResources
        // } else if (this.section == 'group') {
        //   return this.$store.state.resource.groupFeed
        // } else {
        //   return {
        //     list: {
        //       ...this.$store.state.user.feed.list,
        //       careplan_item: this.$store.state.user.feed.list.items
        //     },
        //     isLoading: this.$store.state.user.feed.isLoading
        //   }
        // }
      }
    },
    featuredUsers: {
      get () {
        return this.$store.state.feed.featuredUser;
      }
    },
    isFeaturedUsersLoading: {
      get () {
        return this.$store.state.feed.isFeaturedUserLoading;
      }
    },
    showFeaturedMembersLoading: {
      get () {
        if(!this.featuredUsers && this.isFeaturedUsersLoading){
          return true;
        }else if(this.featuredUsers && !this.featuredUsers.subscribers && this.isFeaturedUsersLoading){
          return true;
        }else if(this.featuredUsers && this.featuredUsers.subscribers && this.featuredUsers.subscribers.length == 0 && this.isFeaturedUsersLoading){
          return true;
        }else
          return false;
      }
    },
    barIcon: {
      get () {
        return require('@/assets/bars.png')
      }
    },
    groupFeedLoader: {
      get () {
        if (this.section == 'journal') {
          return this.$store.state.user.journalFeed.isLoading
        } else if (this.section == 'group' && this.isModeration) {
          return this.$store.state.resource.pendingResources.isLoading
        } else if (this.section == 'group') {
          return this.$store.state.resource.groupFeed.isLoading
        } else {
          return this.$store.state.user.feed.isLoading
        }
      }
    },
    orderedFeeds: function () {
      return !this.pSingleFeedItem ? !this.items ? _.orderBy(this.feed, 'order', 'asc') : this.items : [this.pSingleFeedItem]
      // if (this.section == 'journal') {
      //   return _.orderBy(this.feed.list.careplan_item, 'rrule_parsed_date', 'desc')
      // } else if (this.section == 'group') {
      //   return _.orderBy(this.feed.list.careplan_item, 'rrule_parsed_date', 'desc')
      // } else {
      //   return _.orderBy(this.feed.list.careplan_item, 'rrule_parsed_date', 'desc')
      // }
    },
    isFeed: {
      get () {
        return this.$route.name
      }
    },
    newFeedAvailable: {
      get() {
        return this.$store.getters['user/newActivities']
      }
    },
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    getOffsetnewFeedAvailable: {
      get(){
        return (this.userInfo && this.userInfo.user_type === 'guest') ? 150 : 100
      }
    },
    singleResource: {
      get() {
        return this.$store.state.resource.singleResource;
      }
    },
    pdfIcon(){
      return pdfLogo
    },
  }
}
</script>
